import { createBrowserRouter, redirect } from "react-router-dom";
import AddCourse from "./Pages/Courses/AddCourse";
import Courses from "./Pages/Courses/Courses";
import Root from "./Root";
import Sections from "./Pages/Courses/Sections"
import Account from "./Pages/Account";
import Earnings from "./Pages/Earnings/Earnings";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Root />,
        children: [
            {
                path: '',
                loader: () => {
                    return redirect('/my-courses')
                }
            },
            {
                path: 'my-courses',
                element: <Courses />
            },
            {
                path: 'add-course',
                element: <AddCourse />
            },
            {
                path: 'edit-course/:courseId',
                element: <AddCourse />
            },
            {
                path: '/course-sections/:id',
                element: <Sections />
            },
            {
                path: '/my-account',
                element: <Account />
            },
            {
                path: '/earnings',
                element: <Earnings />
            }
        ]
    }
])

export default router